export class CountTools {
    public static Sum(data: number[]) {
        if (data.length === 0) {
            return 0;
        }

        return data.reduce((a, b) => a + b);
    }
}
